import { MutableRefObject, useRef } from 'react';

import { FormsAuthAPIServiceTypes } from '../../services/FormsAuthServices/APIService';
import { FormsAuthAPIService } from '../../services/FormsAuthServices/APIService/index.api';
import { networkCallWithApisauce } from '../../utils/AuthAPIUtils';

const useFormsAuthRefreshTokenAPIService = () => {
  const FormsAuthRefreshTokenAPIRef: MutableRefObject<FormsAuthAPIServiceTypes | null> =
    useRef(null);

  if (FormsAuthRefreshTokenAPIRef.current === null) {
    FormsAuthRefreshTokenAPIRef.current = new FormsAuthAPIService(
      networkCallWithApisauce
    );
  }

  return {
    formsAuthRefreshTokenAPIService: FormsAuthRefreshTokenAPIRef.current
  };
};

export { useFormsAuthRefreshTokenAPIService };
